import React from 'react';
import type { Tab } from '../types';

interface TabNavigationProps {
  activeTab: Tab;
  onTabChange: (tab: Tab) => void;
  datacenterCount: number;
  loginHistoryTotal: number;
  canReconcileUsers: boolean;
}

const TabNavigationComponent: React.FC<TabNavigationProps> = ({
  activeTab,
  onTabChange,
  datacenterCount,
  loginHistoryTotal,
  canReconcileUsers,
}) => {
  const tabButtonClass = (isActive: boolean) =>
    `px-6 py-3 border-none border-b-[3px] bg-transparent cursor-pointer transition-colors ${
      isActive
        ? 'border-b-blue-600 font-semibold text-blue-600'
        : 'border-b-transparent font-normal text-gray-600 hover:text-blue-600'
    }`;

  return (
    <div className="border-b-2 border-gray-300 mb-6">
      <div className="flex gap-0">
        <button
          type="button"
          onClick={() => onTabChange('details')}
          className={tabButtonClass(activeTab === 'details')}
        >
          User Details
        </button>
        <button type="button" onClick={() => onTabChange('email')} className={tabButtonClass(activeTab === 'email')}>
          Email Subscription
        </button>
        {canReconcileUsers && (
          <button
            type="button"
            onClick={() => onTabChange('datacenters')}
            className={tabButtonClass(activeTab === 'datacenters')}
          >
            Datacenters ({datacenterCount})
          </button>
        )}
        <button type="button" onClick={() => onTabChange('logins')} className={tabButtonClass(activeTab === 'logins')}>
          Login History ({loginHistoryTotal.toLocaleString()})
        </button>
      </div>
    </div>
  );
};

TabNavigationComponent.displayName = 'TabNavigation';

export const TabNavigation = React.memo(TabNavigationComponent);
